var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_200_942",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C4.5816 1 1 4.5816 1 9C1 13.4184 4.5816 17 9 17C13.4184 17 17 13.4184 17 9C17.0016 7.68411 16.6775 6.38828 16.0568 5.228",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C4.5816 1 1 4.5816 1 9C1 13.4184 4.5816 17 9 17C13.4184 17 17 13.4184 17 9C17.0016 7.68411 16.6775 6.38828 16.0568 5.228",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4012 3.4C14.2852 3.4 15.0012 2.8628 15.0012 2.2C15.0012 1.5372 14.2852 1 13.4012 1C12.5172 1 11.8012 1.5372 11.8012 2.2C11.8012 2.8628 12.5172 3.4 13.4012 3.4ZM9.00117 11.8C9.36887 11.8 9.73297 11.7276 10.0727 11.5869C10.4124 11.4461 10.7211 11.2399 10.9811 10.9799C11.2411 10.7199 11.4473 10.4112 11.588 10.0715C11.7287 9.7318 11.8012 9.3677 11.8012 9C11.8012 8.6323 11.7287 8.2682 11.588 7.92849C11.4473 7.58877 11.2411 7.2801 10.9811 7.0201C10.7211 6.7601 10.4124 6.55385 10.0727 6.41314C9.73297 6.27242 9.36887 6.2 9.00117 6.2C8.25857 6.2 7.54637 6.495 7.02127 7.0201C6.49617 7.5452 6.20117 8.25739 6.20117 9C6.20117 9.74261 6.49617 10.4548 7.02127 10.9799C7.54637 11.505 8.25857 11.8 9.00117 11.8Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7988 2V9V2Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7988 2V9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_200_942)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_200_942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.601562 -0.599609H18.5984V18.6004H-0.601562V-0.599609Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_200_942",
    x: -4.60156,
    y: -0.599609,
    width: 27.2002,
    height: 27.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_200_942"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_200_942",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.0b60ead073b9f1fdb42c5620c3e3fd38.svg";
export { ForwardRef as ReactComponent };